import CreateAccountContext, {
    CreateAccountProvider,
    ECreateAccountUiState,
} from '../../contexts/CreateAccountContext';
import { ERoutes } from '../../util/constants';
import { Redirect } from 'react-router-dom';
import { Loader } from '../../components/Loader/Loader';
import { Switch, Route } from 'react-router';
import CreateAccountSuccess from '../../components/CreateAccountSuccess/CreateAccountSuccess';
import CreateAccountForm from '../../components/CreateAccountForm/CreateAccountForm';
import CreateAccountConfirm from '../../components/CreateAccountConfirm/CreateAccountConfirm';
import { FC, ReactElement, useContext } from 'react';
import PageLayoutV2 from '../../layout/PageLayoutV2/PageLayoutV2';
import { Stack } from '@mui/material';

const CreateAccountRouter: FC = () => {
    const { email, submitVerifyPasscode, resendVerifyPasscode } = useContext(CreateAccountContext);
    return (
        <Switch>
            <Route exact path={ERoutes.createAccount}>
                <CreateAccountForm />
            </Route>
            <Route path={ERoutes.createAccountConfirm}>
                <CreateAccountConfirm />
            </Route>
            <Route path={ERoutes.createAccountSuccess}>
                <CreateAccountSuccess
                    email={email}
                    onVerifyPasscode={submitVerifyPasscode}
                    onResendPasscode={resendVerifyPasscode}
                />
            </Route>
        </Switch>
    );
};

const CreateAccountUi: FC = () => {
    const { createAccountUiState } = useContext(CreateAccountContext);
    let createAccountUi: ReactElement;
    switch (createAccountUiState) {
        case ECreateAccountUiState.default:
            createAccountUi = (
                <PageLayoutV2>
                    <Stack direction={'row'} sx={{ justifyContent: 'center' }}>
                        <Loader />
                    </Stack>
                </PageLayoutV2>
            );
            break;
        case ECreateAccountUiState.ready:
            createAccountUi = <CreateAccountRouter />;
            break;
        case ECreateAccountUiState.confirm:
            createAccountUi = (
                <>
                    <CreateAccountRouter />
                    <Redirect push to={ERoutes.createAccountConfirm} />
                </>
            );
            break;
        case ECreateAccountUiState.success:
            createAccountUi = (
                <>
                    <CreateAccountRouter />
                    <Redirect to={ERoutes.createAccountSuccess} />
                </>
            );

            break;
        default:
            throw new Error('Create Account UI state set incorrectly');
    }
    return createAccountUi;
};

const CreateAccountScreen: FC = () => {
    return (
        <CreateAccountProvider>
            <CreateAccountUi />
        </CreateAccountProvider>
    );
};

export default CreateAccountScreen;
